import { Box, Typography } from '@mui/material';

const LiveTools = () => {
  return (
    <Box
    sx={{
      mb: '10px',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    }}>
      <Typography
      sx={{ m: 1 }}
      variant="h5">
       Live Attendance List
      </Typography>
      <Box
        sx={{ m: 1 }}
        onClick={() => {
          props.setIsAddButton(true);
          props.setEditAddParts([]);
          props.setOpen(true);
        }}>
      </Box>
    </Box>
  )
}

export default LiveTools
